import { useContext } from "react";

import { ProductData } from "data/product/products";
import { StorefrontData } from "data/storefront";

import { CreatorEditingContext } from "~/hooks/creatorEditing/creatorEditingProvider";

export enum CreatorSavingType {
  PRODUCT = "product",
  STOREFRONT = "storefront",
}

export const errorBorderStyle = { outline: "2px solid red" };

export const useCreatorEditing = () => {
  return useContext(CreatorEditingContext);
};
